const initialState = {
  listings: [],
  page: 1,
  filtersFormState: {
    data: {
      // sort: 'remainingValue',
    }
  },
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case 'SET_LISTINGS': {
      const { listings, page } = payload;
      return {
        ...state,
        listings,
        page,
      };
    }
    case 'LISTINGS_FILTERS_CHANGE': {
      const { filtersFormState } = payload;
      return {
        ...state,
        filtersFormState,
        page: 1,
      };
    }
    case 'LISTINGS_NEXT_PAGE': {
      const page = Number(state.page);
      return {
        ...state,
        page: page + 1,
      };
    }
    case 'LISTINGS_PREVIOUS_PAGE': {
      const page = Number(state.page);
      return {
        ...state,
        page: page > 1 ? page - 1 : 1,
      };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/Ebay/Listings/Listings.reducer.js